import * as Lib from "metabase-lib";
import type Question from "metabase-lib/v1/Question";

/**
 * Whether the current user can open this dashboard question in the query builder.
 *
 * Dashboard results only require view-data. Opening the question requires
 * create-queries on its database, reported as `can_create_queries` on query metadata.
 */
export function canDrillThroughDashboardCardTitle(
  question: Question,
): boolean {
  // Read the id off the card. `question.database()` compiles a Lib query, which
  // is wasted work on every dashcard and throws for queries Lib does not support.
  const databaseId = question.datasetQuery()?.database;
  if (databaseId == null) {
    return false;
  }

  const database = question.metadata().database(databaseId);
  if (!database) {
    return false;
  }

  if (database.can_create_queries !== undefined) {
    return database.can_create_queries;
  }

  // Payloads that predate the flag only tell us about native write access.
  try {
    const { isNative } = Lib.queryDisplayInfo(question.query());
    return isNative && database.native_permissions === "write";
  } catch {
    // Lib can't read this query, so don't offer a title link.
    return false;
  }
}
